<div class="container-fluid mb-2 h-100">
    <div class="row">
        <div class="col-12 mt-2">
            <mat-tab-group mat-align-tabs="start" (selectedTabChange)="tabChanged($event)">
              <mat-tab label="Nova">
                <cadastro-regra #cadastroRegra></cadastro-regra>
              </mat-tab>
              <mat-tab label="Importação em lote">
                <app-importacao-lote [tipo]="tipo" (onBaixarModelo)="downloadModelo()" #regraImportacaoLote></app-importacao-lote>
              </mat-tab>
              <mat-tab label="Gerenciar registros">
                <gerenciador-registro #gerenciadorRegistros></gerenciador-registro>
              </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
